import { PhoneNumber, UserNumber } from '../codegen/graphql';

export type TelNoLike = {
    countryCode?: string;
    number?: string;
};

export function formatPhoneNumber(telNo?: TelNoLike | null): string {
    if (!telNo?.number) return '';
    const countryCode = telNo.countryCode ?? '';
    return `${countryCode}${telNo.number}`.trim();
}

export default function stringifyNumber(
    phoneNumber?: PhoneNumber | UserNumber | null,
) {
    if (!phoneNumber) {
        return '';
    }

    if (!phoneNumber.number || !phoneNumber.dialingCode) {
        return '';
    }

    return `+${phoneNumber.dialingCode}${phoneNumber.number}`;
}
